import React from 'react'
import UpdateForm from '../form/UpdateForm'

const UpdateView = () => {
  return (
    <>
        <UpdateForm />
    </>
  )
}

export default UpdateView